<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <el-card v-if="this.loadingFormSubmit == false" style="margin: 100px 6% 6%;">
    <h5>Enter Your Email to resend the Registration Confirmation Email</h5>
    <el-input
      :rows="4"
      placeholder="Sample@gmail.com"
      v-model="form.email"
      required
    ></el-input>
    <el-button @click.native="SubmitForm"
    style="margin-top:10px;"
    >Submit</el-button>
    <h3>{{ usermessage }}</h3>
    </el-card>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  data() {
    return {
      form: {
        email: ""
      },
      usermessage: "",
      loadingFormSubmit: false
    };
  },
  methods: {
    SubmitForm() {
      
      this.loadingFormSubmit = true;

      EventService.ResendRegistrationConfirmationEmail(this.form.email).then(() => {
          this.usermessage = "Your confirmation email has been sent";
          this.loadingFormSubmit = false;
        })
        .catch(error => {
            console.log(error);
            this.loadingFormSubmit = false;
        });
    }
  }
};
</script>

<style></style>
